/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";

const Container = styled.div`
  position: relative;
  height: 100px;
`;

// you can custoize the styling of the content by selecting
// #content in parent components
const Content = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1em;
  @media (max-width: 600px) {
    padding: 1em 0.2em;
  }
`;

// you can custoize the styling of the background image by selecting
// #img in parent components
const Image = styled.div`
  background-image: radial-gradient(ellipse closest-side, rgba(0, 0, 0, 0.75), var(--background)), url("${props =>
    props.src}");
  background-size: cover;
  background-position: center center;
  height: 500px;
  width: 600px;
  position: absolute;
  top: -150px;
  z-index: -1;
  right: -50px;
  border-radius: 0 60px 0 0;
  @media (max-width: 600px) {
    height: 300px;
    width: 300px;
    top: -100px;
  }
`;

export default function({ children, src, ...props }) {
  return (
    <Container {...props}>
      <Image id="img" src={src} />
      <Content id="content">{children}</Content>
    </Container>
  );
}